// Core types and interfaces
export * from './lib/core/types';

// Billing types, mapping, and helpers
export * from './lib/billing';

// Mathematical utilities
export * from './lib/utils/math';

// Configuration management
export * from './lib/jamcamConfig';
export * from './lib/modelDiagnosticsSettings';

// Fretboard classes and geometry
export * from './lib/fretboardClasses';

// ML integration and overlay rendering
export * from './lib/roboflowOverlay';

// Legacy exports (main library entry point)
export * from './lib/jamcam-svc';

// Portable analytics schema (browser transport is imported separately).
export * from './lib/analytics/contract';

export * from './lib/tabs/types';
export * from './lib/tabs/ascii-tab';

export * from './lib/tabs/harmony';
export * from './lib/songs';
export * from './lib/tabs/community';
